import {
	type CharacterStreamRequest,
	characterLastMessageApiV1CharacterCharacterLastMessageGet,
} from "@/shared/api/generated-backend"
import { authorizedFetch } from "@/shared/api/http"
import { backendBaseUrl } from "@/shared/lib/platform"
import type { CharacterType } from "../model/types"

// Стрим идёт мимо сгенерированного клиента, поэтому транспорт собираем руками.
export function getCharacterStreamConfig(
	character: CharacterType,
	userId: number,
) {
	const body: Omit<CharacterStreamRequest, "prompt"> = { user_id: userId }
	return {
		api: `${backendBaseUrl}/api/v1/character/${character}/stream`,
		fetch: authorizedFetch,
		body,
	}
}

export async function getCharacterLastMessage(
	character: CharacterType,
	userId: number,
) {
	return characterLastMessageApiV1CharacterCharacterLastMessageGet({
		path: { character },
		query: { user_id: userId },
	})
}
